<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Cruise Odaları</h3>
      <a @click="createCruiseRoom" href="javascript:void(0)" class="theme-btn theme-btn-small"><i class="la la-plus mr-1"></i>Yeni Oda Yarat</a>

    </div>

    <v-app>
      <v-data-table
          :headers="headers"
          :items="cruiseRoomList"
          :items-per-page="5"
          class="elevation-1"
          :search="search"
          :custom-filter="filterCruiseRooms">
        <template v-slot:top>
          <v-text-field
              v-model="search"
              label="Arama"
              class="mx-4"/>
        </template>
        <template v-slot:item.roomId="{ item }">
          <tr>
          <!--            :color="getColor(item.calories)"-->
          <!--            dark-->
  <!--        <v-chip>-->
            {{ getRoom(item.roomId) }}
  <!--        </v-chip>-->
          </tr>
        </template>
        <template v-slot:item.delete="{ item }">
            <div class="table-content mr-2" @click="deleteCruiseRoom(item)">
              <a style="color: white" href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-trash"></i>
              </a>
            </div>
        </template>
        <template v-slot:item.edit="{ item }">
          <div class="table-content" @click="showCruiseRoomDetail(item)">
            <a style="color: white" href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit"><i class="la la-edit"></i></a>
          </div>
        </template>
      </v-data-table>
    </v-app>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>
import messagePopupManager from "../../../util/messagePopupManager";

export default {
  name: "CruiseRoomList",
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Oda Numarası',
          align: 'start',
          sortable: true,
          value: 'roomNumber',
        },
        {
          text: 'Oda Tipi',
          sortable: true,
          value: 'roomId',
          formatter: this.getRoom()
        },
        {
          text: 'ROS',
          sortable: true,
          value: 'ros',
        },
        {
          text: 'Max yetişkin',
          sortable: true,
          value: 'maxAdultCount',
        },
        {
          text: 'Max yolcu',
          sortable: true,
          value: 'maxGuestCount',
        },
        {
          text: 'Delete',
          value: 'delete',
        },
        {
          text: 'Edit',
          value: 'edit',
        }
      ]
    }
  },
  computed:{
    cruiseRoomList:{
      get(){
        if(this.$store.getters.getCruiseRoomList === null|| this.$store.getters.getCruiseRoomList === undefined){
          return [];
        }
        return this.$store.getters.getCruiseRoomList;
      }
    },
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    },
    cabinTypeList:{
      get(){
        return this.$store.getters.getCabinTypeList
      }
    },
    roomMap:{
      get(){
        let roomList = this.$store.getters.getRoomList;
        if(roomList == null){
          return null;
        }
        return roomList.reduce(function (map, cabinType) {
          map[cabinType.id] = cabinType;
          return map;
        }, {});
      }
    }
  },
  methods:{
    filterCruiseRooms (value, search, item) {
      if(value == null || search == null){
        return false;
      }
      if(this.roomMap !== undefined){
        if(typeof value === 'number'){
          if(this.roomMap[item.roomId].name.toLowerCase().indexOf(search.toLowerCase()) !== -1){
            return true;
          }
        }
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
    showCruiseRoomDetail(cruiseRoom){
      let editCruiseRoom = JSON.parse(JSON.stringify(cruiseRoom));
      this.$store.commit("setCruiseRoom", editCruiseRoom);

      $("#cruiseRoomPopup").modal('show')
    },
    createCruiseRoom(){
      this.$store.commit("setCruiseRoom",{id:null});
      $("#cruiseRoomPopup").modal('show')
    },
    getRoom(roomId){
      if(this.roomMap === undefined || this.roomMap === null){
        return "-"
      }

      let room = this.roomMap[roomId];
      if(room === undefined){
        return "";
      }else{
        return room.name;
      }
    },
    deleteCruiseRoom(cruiseRoom){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteCruiseRoom", cruiseRoom)
      })
    }
  },
  beforeCreate() {
    // this.$store.dispatch("loadCruiseRoomList", this.$store.getters.getCruise.id);
  },
  mounted() {
    this.$nextTick(()=> {

      // this.$nextTick(()=> {
      //
      // }
    });
  }
}
</script>

<style scoped>

</style>